module.exports = __webpack_public_path__ + "img/mozzo 5 balcone.5a412fb7.jpeg";